/**
 * Analytics identifiers for WELDING PROJECT PLANS™.
 *
 * The inherited IDs belonged to the previous product and were removed.
 * Leave a value empty to keep that integration switched off.
 */
export const META_PIXEL_ID = '1998322494134236'
export const CLARITY_PROJECT_ID = ''
export const FACEBOOK_DOMAIN_VERIFICATION = ''
